import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";

import { GlobalState } from "contexts/GlobalState";
import { GlobalSearchResult } from "components/GlobalSearchResult";
import { EmptyResults } from "components/EmptyResults";

import "./style.scss";

const GlobalSearchResults = ({ labels }) => {
    const [globalSearch, setGlobalSearch] = GlobalState("search");
    const [results, setResults] = useState({
        programs: [],
        faculties: [],
        general_content: []
    });
    const findGlobalResults = () => {
       
        const tempPrograms = [];
        const tempFaculties = [];
        const tempGeneralContent = [];
        if (globalSearch.results) {
            globalSearch.results.map(result => {
                if (result.field_faculty_mamta && !tempFaculties.includes(result.field_faculty_mamta)) {
                    tempFaculties.push(result.field_faculty_mamta);
                }
                result.field_short_name?.map(shortName => {
                    if (!tempFaculties.includes(shortName))
                        tempFaculties.push(shortName);
                })
                if (result.type == 'general_content') {
                    tempGeneralContent.push(result);;
                }
                else {
                    tempPrograms.push(result);
                }
              
             })
            return [tempPrograms, tempFaculties, tempGeneralContent];
        }
        return [null, null,null];
    }

    useEffect(() => {
            const [programResults, facultyResults, generalContentfacultyResults] = findGlobalResults();
        if (programResults && facultyResults) {
            setResults({
                ...results,
                programs:programResults,
                faculties:facultyResults,
            })
        }
        if (generalContentfacultyResults) {
            setResults({
                ...results,
                programs:programResults,
                faculties:facultyResults,
                general_content:generalContentfacultyResults
            })
        }
    }, [globalSearch]);

    const showResults = (results) => {
        let faculty = false;
        return (
            <div>
                {Object.keys(results).map((name, i) => (
                    <div>
                        {faculty = name == "faculties" ? true : false}
                        {results[name][0] ?
                            <div className="results-section">
                                <h2 aria-label={labels[name]} tabIndex="0" className="section-title" key={i}>{labels[name]}</h2>
                                {
                                    results[name].map((program, index) => (
                                        <GlobalSearchResult
                                            item={program}
                                            key={index}
                                            isFaculty={faculty}
                                        />
                                    )
                                    )
                                }
                            </div> : null}
                    </div>
                ))}
            </div>
        )
    }
    
    return (
        <Container className="global-search-results">
            {!globalSearch.results?null:
            !results.programs[0] && !results.faculties[0] && !results.general_content[0] ?
                <EmptyResults labels={labels}></EmptyResults>:showResults(results) }     
        </Container>
    )
}

export default GlobalSearchResults;